import React from 'react'
import { Container, Image } from 'react-bootstrap'
import { API_SERVICES } from '../..'

const PDTAHeader = ({ label }) => {
  return <Container fluid className='p-4 bg-white text-center border-bottom'>
  <div className='d-flex flex-row align-items-center justify-content-center'>
    <Image src={API_SERVICES.PDTA.IMAGE} style={{ width: '100%', maxWidth: '150px' }} className='me-4' />
    <div className='text-primary'>
      <h1 className='text-start fw-bold'>{ API_SERVICES.PDTA.NOME }</h1>
      { label && <h4 className='text-start'>{label}</h4> }            
    </div>
  </div>
</Container>
}

export default PDTAHeader